import React, { useState } from "react";
import { Space, Modal, Typography, Row, Col, Button, Table, Flex, Alert, theme,Tag, Tooltip, Divider, Input } from 'antd';
import { CheckOutlined, CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { findNthTermInAnEntityList, generateRandom10DigitNumber } from "../../../utils";
import { wrapInInfotip } from "../helper";
const { Title, Text, Paragraph } = Typography;

const AddChoicesModalForGlobalStandard = (props) => {

  const {
    openGlobalStandardModal,
    handleCancel,
    addStandardChoicesBulk,
    systemPurposes,
    defaulStandardChoiceNames,
    regulationCategories,
    customPrivacyChoiceOptions,
    setCustomPrivacyChoiceOptions
    // disabledSellOrShare,
    // stateStringRegions
  } = props;

  const { token } = theme.useToken()
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowKeys2, setSelectedRowKeys2] = useState([]);
  const [dataSource2, setDataSource2] = useState(
    customPrivacyChoiceOptions
    .concat(systemPurposes.map((item, index) => ({
      ...item,
      key: item.id || index,
    })))
  );
  const [editingRow, setEditingRow] = useState(null);
  const [validationError, setValidationError] = useState("");

  const handleAddNew = () => {
    let nThPrivacyChoice = findNthTermInAnEntityList(dataSource2?.map(a => a.privacyChoice), "Privacy Choice");
    const newRow = { key: `custom_${generateRandom10DigitNumber()}`, privacyChoice: nThPrivacyChoice }
    setEditingRow(newRow);
  };

  const handleSaveNewChoice = () => {
    const trimmedName = editingRow?.privacyChoice?.trim();

    // Validation logic
    const isDuplicate =
      dataSource2.some((item) => item.privacyChoice === trimmedName) ||
      defaulStandardChoiceNames.some((item) => item === trimmedName) || 
      regulationCategories.some((item) => item.privacyChoice === trimmedName);

    if (!trimmedName) {
      setValidationError("You cannot save this as empty");
      return;
    }
    if (isDuplicate) {
      setValidationError("This name already exists");
      return;
    }

    // Prepend the new choice to the dataSource2
    setDataSource2((prevDataSource) => [
      { ...editingRow, privacyChoice: trimmedName },
      ...prevDataSource,
    ]);
    setCustomPrivacyChoiceOptions((records) => [editingRow, ...records]);
    setSelectedRowKeys2((rows) => [...rows, editingRow.key]);
    setEditingRow(null);
    setValidationError(""); // Clear validation error on successful save
  };

  const handleCancelNewChoice = () => {
    setEditingRow(null);
    setValidationError(""); // Clear validation error on cancel
  };

  const columns = [
    {
      title: "Commonly Used",
      fixed: "left",
      dataIndex: "privacyChoice",
      render: (privacyChoice, record) => {
        if (editingRow && editingRow.key === record.key) {
          return (
            <Space direction="vertical" style={{ width: "100%" }}>
              <Flex justify="space-between" align="center" gap={token.margin}>
                <Input
                  value={editingRow?.privacyChoice}
                  onChange={({target : {value}}) => {
                    setEditingRow((record) => ({
                      ...record,
                      privacyChoice: value
                    }))
                    setValidationError(""); // Clear validation error on input change
                  }}
                  status={validationError ? "error" : null}
                />
                <Space size={token.margin}>
                  {wrapInInfotip(
                    <Button
                      icon={<CheckOutlined />}
                      type="link"
                      onClick={handleSaveNewChoice}
                    />
                    , "Add"
                  )}
                  {wrapInInfotip(
                    <Button
                      icon={<CloseOutlined />}
                      type="link"
                      onClick={handleCancelNewChoice}
                    />
                    , "Cancel"
                  )}
                </Space>
              </Flex>
              {validationError && (
                <Text type="danger">
                  {validationError}
                </Text>
              )}
            </Space>
          );
        }
        return (
          <Paragraph ellipsis={{ tooltip: { title: privacyChoice }, rows: 2 }}>
            {privacyChoice}
          </Paragraph>
        );
      },
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys)
    },
  };
  const rowSelection2 = {
    selectedRowKeys: selectedRowKeys2,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys2(selectedRowKeys)
    },
    getCheckboxProps: (record) => ({
      disabled: record.key === editingRow?.key,
    }),
  };

  const dataSource1 = defaulStandardChoiceNames.map((item, idx) => ({privacyChoice: item, key: `custom_${item}`}))

  const handleOnOk = () => {
    let iabIds = selectedRowKeys2.filter((key) => !key.includes("custom_"))
    let customChoices = dataSource1.filter((item) => selectedRowKeys.includes(item.key)).concat(dataSource2.filter((item) => selectedRowKeys2.includes(item.key) && !iabIds.includes(item.key)));
    addStandardChoicesBulk(iabIds, customChoices);
  }
    return (
      <Modal
        title={"Add Privacy Choices"}
        open={openGlobalStandardModal}
        width={"720px"}
        closable={true}
        destroyOnClose={true}
        onCancel={() => handleCancel('globalStandard')}
        okText={<>Add selected choices {selectedRowKeys.length + selectedRowKeys2.length? `(${selectedRowKeys.length + selectedRowKeys2.length})` : null}</>}
        onOk={handleOnOk}
        cancelText={openGlobalStandardModal}
        okButtonProps={{disabled: (selectedRowKeys.length + selectedRowKeys2.length) === 0}}
      >
        <Row gutter={[0, 16]} >
          <Col span={24}>
            <Flex justify="space-between" align="center" gap={token.margin}>
              <Text type="secondary">
                Select the Privacy choices you want to add to your list:
              </Text>
              <Button type="primary" disabled={editingRow} icon={<PlusOutlined/>} iconPosition="start" onClick={handleAddNew}>New</Button>
            </Flex>
          </Col>
          <Col span={24} style={{maxHeight: 420, overflowY: "scroll"}}>
            <Table
              columns={columns}
              dataSource={dataSource1}
              rowSelection={rowSelection}
              pagination={false}
            />
            <Table
              columns={columns.map((item) =>({...item, title: "Additional Options"}))}
              dataSource={editingRow ? [editingRow, ...dataSource2] : dataSource2}
              rowSelection={rowSelection2}
              pagination={false}
            />
          </Col>
        </Row>
      </Modal>
    )
  
}

export default AddChoicesModalForGlobalStandard